<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">Файлы</a>
          </li>
          <li>
            <a href="#" @click.prevent="add()">Загрузить</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
    <section class="uk-margin">
      <b-field grouped group-multiline>
        <b-field label="Сортировка">
          <b-select v-model="filters.order" @input="pageChange()">
            <option value="asc">Восходящая (ASC)</option>
            <option value="desc">Нисходящая (DESC)</option>
          </b-select>
        </b-field>
        <b-field label="На страницу">
          <b-select v-model="filters.limit" @input="pageChange()">
            <option
              v-for="option in limits"
              :value="option"
              :key="option">
              {{ option }} шт.
            </option>
          </b-select>
        </b-field>
        <b-field label="Состояние">
          <b-field>
            <b-select v-model="filters.is_active" placeholder="Filter by State" @input="pageChange()">
              <option
                v-for="option in states"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearState()">X</button>
            </p>
          </b-field>
        </b-field>
      </b-field>
    </section>
    <section class="uk-margin">
      <b-table
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="filters.order">
        <template slot-scope="props" @click="click">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="date" label="Дата загрузки" width="40" sortable date>
            <!-- {{ props.row.date }} -->
            {{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:ss:mm') }}
          </b-table-column>
          
          <b-table-column field="name" label="Наименование" sortable>
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="file_name" label="Имя файла" sortable>
            {{ props.row.file_name }}
          </b-table-column>

          <b-table-column field="file_extension" label="Формат" sortable>
            {{ props.row.file_extension }}
          </b-table-column>

          <b-table-column field="full_path" label="Полный путь" sortable>
            {{ props.row.full_path }}
          </b-table-column>

          <b-table-column field="relative_path" label="Путь" sortable>
            {{ props.row.relative_path }}
          </b-table-column>
          
          <b-table-column label="Действие" centered>
            <div class="block" v-if="props.row.is_active != false">
              <a href="#" @click="importRow(props.row.id)" style="margin-right: .35rem;" v-if="props.row.is_active != false">
                <b-icon icon="play" type="is-dark" size="is-small"></b-icon>
              </a>
              <a href="#" @click="dropRow(props.row.id)" v-if="props.row.is_active != false">
                <b-icon icon="trash" type="is-danger" size="is-small"></b-icon>
              </a>
            </div>
            <p v-if="props.row.is_active == false">
              <b-icon
                icon="trash"
                size="is-large">
              </b-icon>
            </p>
          </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="sad-tear"
                size="is-large">
              </b-icon>
            </p>
            <p>Данных нет.</p>
          </div>
        </section>
      </template>
      </b-table>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
  </div>
</template>

<script>

import { EventBus } from '@/utils'

export default {
  name: "FileTable",
  data() {
    const data = []
    const limits = [
      5, 10, 20, 25, 50, 75, 100
    ]
    const states = [
      {
        id: true,
        name: "Активные"
      },
      {
        id: false,
        name: "Удаленные"
      }
    ]
    return {
      data: data,
      limits: limits,
      states: states,
      currentPage: 1,
      total: 0,
      filters: {
        order: 'asc',
        is_active: null,
        limit: 25
      },
    }
  },
  computed: {
    //
  },
  mounted: function() {
    this.$store.dispatch('getFiles')
      .then(response => {
        let data = response.data.data;
        data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })

    EventBus.$on('successUploadFile', (data) => {
      this.data.push(data)
    })

    EventBus.$on('successImportFile', (data) => {
      this.$toast.open({
        message: this.$i18n.t('admin.file_import_success'),
        type: 'is-success',
        position: 'is-bottom'
      })
    })

    EventBus.$on('failedImportFile', (msg) => {
      this.$toast.open({
        message: `${this.$i18n.t('admin.file_import_error')} ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
    })

  },
  beforeDestroy: function(){
    EventBus.$off('successUploadFile')
    EventBus.$off('successImportFile')
    EventBus.$off('failedImportFile')
  },
  methods: {
    add(){
      EventBus.$emit("showModal", "file.upload", null)
    },
    dropRow(id) {
      let $this = this
      this.$dialog.confirm({
        message: $this.$i18n.t('admin.file_delete_message'),
        cancelText: $this.$i18n.t('admin.no'),
        confirmText: $this.$i18n.t('admin.yes'),
        onConfirm: () => {
          $this.$store.dispatch('deleteFile', id)
          this.pageChange()
        }
      })
    },
    importRow(id) {
      let $this = this
      this.$dialog.confirm({
        message: $this.$i18n.t('admin.file_import_message'),
        cancelText: $this.$i18n.t('admin.no'),
        confirmText: $this.$i18n.t('admin.yes'),
        onConfirm: () => {
          $this.$store.dispatch('importFile', id)
        }
      })
    },
    clearState(){
      this.filters.is_active = null
      this.pageChange()
    },
    pageChange(page){
      if(page){
        this.currentPage = page
      }
      this.$store.dispatch('getPageFiles', { page: this.currentPage, filters: this.filters })
        .then(response => {
          let data = response.data;
          
          this.data = []
          this.total = data.total
          data.data.forEach((item) => {
            this.data.push(item)
          })

        })
        .catch(error => {
          this.data = []
        })
    }
  }
}
</script>
<style scoped>
</style>